import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CustomerTable from './CustomerTable';
const CustomerListPage = () => {
    return (_jsx("div", { className: "container-fluid", children: _jsx(CustomerTable, {}) }));
};
export default CustomerListPage;
